import ReactDOM from 'react-dom/client';

//
import App from './App';
import './index.css'; // Adjust the path if necessary
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
// import 'sweetalert2/src/sweetalert2.scss';
// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
